
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        letter: {
            required: true,
            type: String,
        },
        color: {
            required: true,
            type: String,
        }
    },
})
